import * as React from 'react';
import
{
    DragDropContext,
    Droppable,
} from 'react-beautiful-dnd';
import
{
    Card,
    ListItem,
    CardContent,
    Box,
} from '@mui/material';
import DraggableListItem from './draggableListItem';

const DraggableList = ({ classes, data, onDragEnd, editRow, modPermission, showDelete, handleDelete, showModuleSetting, onModuleSettingClick }) =>
{
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-list">
                {provided => (
                    // <List>
                    <div ref={provided.innerRef} {...provided.droppableProps} className={classes.listContent}>
                        {data && data.length > 0 ? (
                            data.map((item, index) => (
                                <DraggableListItem item={item} index={index} key={`dragitem_${index}`} showDelete={showDelete} handleDelete={handleDelete} editRow={editRow} onModuleSettingClick={onModuleSettingClick} showModuleSetting={showModuleSetting} modPermission={modPermission} />
                            ))
                        )
                            :
                            (
                                <ListItem className={classes.listItemContent}>
                                    <Card
                                        classes={{ root: classes.paperContent }}
                                        sx={{ width: '100%' }}>
                                        <CardContent
                                            sx={{ p: 2 }}
                                            className={classes.cardContent}>
                                            <Box className={classes.rowContent}>
                                                No data found
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ListItem>
                            )}
                    </div>
                    // </List>
                )}
            </Droppable>
        </DragDropContext>
    )
}
export default React.memo(DraggableList);
// const DraggableList = React.memo((props) => {
//   return (
//     <DragDropContext onDragEnd={props.onDragEnd}>
//       <Droppable droppableId="droppable-list">
//         {provided => (
//           <div ref={provided.innerRef} {...provided.droppableProps}>
//             {props.items.map((item, index) => (
//               <DraggableListItem item={item} index={index} key={item.id} />
//             ))}
//             {provided.placeholder}
//           </div>
//         )}
//       </Droppable>
//     </DragDropContext>
//   );
// });

// export default DraggableList;